import { useWidgetSettings } from "../widget/useWidgetSettings";
import { createTheme, Theme } from "@mui/material";
import {
  FONT_FAMILY_HEB,
  FONT_FAMILY_LATIN,
} from "../components/consts/sizeConsts";
import { MainLayoutViewClassName } from "../layout/MainLayoutViewClassName";
import { ThemeSettings } from "@kahunmedical/common-configuration";
import { createCommonTheme } from "fe-web-components/styles/createCommonTheme";

export const HELIX_CLINIC_ID = "8da4bffe-26ab-4fc1-94b8-f70246077959";

export interface PartnerThemeParams {
  theme: Theme;
  settings: ThemeSettings;
}

export const usePartnerTheme = (
  locale: string,
  external?: ThemeSettings,
  clinicId?: string,
): PartnerThemeParams => {
  const DEFAULT_THEME = "patient1st";

  // useEffect(() => {
  //   console.log("locale:", locale);
  // }, [locale]);

  const { partnerId } = useWidgetSettings();

  const themeId = partnerId || DEFAULT_THEME;

  // First read the default theme
  let settings = require(`patient/src/themes/${DEFAULT_THEME}Theme.json`);

  // Then try to load other themes
  try {
    settings = require(`patient/src/themes/${themeId.toLowerCase()}Theme.json`) as ThemeSettings;
  } catch (e) {}

  if (external && external.colors) {
    settings = external;
  }

  const createThemeFromSettings = () => {
    const fontFamily =
      settings?.fontFamily ||
      (locale === "he" ? FONT_FAMILY_HEB : FONT_FAMILY_LATIN);

    // console.log("fontFamily:", fontFamily);

    const PatientThemeSettings = createTheme(
      createCommonTheme(MainLayoutViewClassName, fontFamily, {
        components: {
          MuiCssBaseline: {
            // styleOverrides: `
            //     html: {
            //         --kahun-version: '${version}';
            //       }
            //       body: {
            //         overflowY: "auto";
            //       }
            //       #language-changer: {
            //         ${Object.entries(settings?.colors)
            //           .map(([color, value]) => `${color}: "${value}";`)
            //           .join()}
            //       }
            //       .disable-text-selection: {
            //         -moz-user-select: none; /* firefox */
            //         -webkit-user-select: none; /* Safari */
            //         -ms-user-select: none; /* IE*/
            //         user-select: none; /* Standard syntax */
            //       }
            //       .hvm-kahun-wrapper: {
            //         margin: 0;
            //         height: 100vh;
            //         padding: 0;
            //       }
            //       .hvm-kahun-wrapper #kahun-patient: {
            //         height: 100%;
            //       }
            //       .hvm-kahun-wrapper #kahun-patient .main-app.embedded, .hvm-kahun-wrapper #kahun-patient .kahun-main-layout-view: {
            //         background: "transparent";
            //       }
            //       @media (max-width: 599.95px): {
            //         .hvm-kahun-wrapper: {
            //           height: calc(100vh - ${isIos() ? 136 : 113}px)};
            //         }
            //         .hvm-kahun-wrapper .diagram: {
            //           height: calc(100vh - 369px);
            //         }
            //       }
            //     }
            //   `,
          },
          MuiScopedCssBaseline: {
            styleOverrides: {
              root: {
                height: "100%",
                ...settings?.colors,
                fontSize: "16px",
                fontWeight: 300,
                lineHeight: "1.15",
                overflow: "hidden",
                boxSizing: "border-box",
                [`& .${MainLayoutViewClassName} input`]: {
                  boxSizing: "border-box",
                },
                // [`& .${MainLayoutViewClassName} button, & .${MainLayoutViewClassName} button:hover, & .${MainLayoutViewClassName} button:focus`]: {
                //   color: PatientColorMap.Default,
                //   backgroundColor: PatientColorMap.Unselected,
                //   boxShadow: "none",
                //   padding: "5px 14px",
                // },
              },
            },
          },
          MuiChip: {
            styleOverrides: {
              root: {
                fontFamily: fontFamily,
              },
            },
          },
          MuiButton: {
            styleOverrides: {
              root: {
                color: "rgba(0, 0, 0, 0.87)",
                textTransform: "none",
              },
            },
          },
        },
        palette: {
          primary: {
            main: settings?.colors?.["--primary"],
            light: settings?.colors?.["--primary-light"],
            dark: settings?.colors?.["--primary-dark"],
          },
          background: {
            default:
              // Hack to make sure the background is transparent in white
              clinicId !== HELIX_CLINIC_ID ? "transparent" : "rgb(255,255,255)",
          },
        },
      }),
    );

    return PatientThemeSettings;
  };

  const theme = createThemeFromSettings();

  return { settings, theme };
};
